import { useEffect, useState } from "react";
import { TimezoneOption } from "../features/timezones/timezones.types";
import { getTimezoneOptions } from "../features/timezones/utils/getTimezoneOptions";
import { useUserTimezoneOption } from "./useUserTimezoneOption";

export function useTimezoneOptions() {
  const timezones = getTimezoneOptions();

  const userTimezoneOption = useUserTimezoneOption();

  const [userTimezone, setUserTimezone] = useState<TimezoneOption | null>(null);

  const [selectedTimezone, setSelectedTimezone] =
    useState<TimezoneOption | null>(userTimezone);

  useEffect(() => {
    if (!timezones) return;
    if (!userTimezoneOption) return;

    setUserTimezone(userTimezoneOption);
    setSelectedTimezone(userTimezoneOption);
  }, [timezones, userTimezoneOption]);

  const handleTimezoneChange = (option: TimezoneOption | null) => {
    setSelectedTimezone(option as TimezoneOption);
  };

  return {
    timezones,
    selectedTimezone,
    handleTimezoneChange,
  };
}

export default useTimezoneOptions;
